import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SubcategoriesPage } from './subcategories';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '../../components/components.module';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    SubcategoriesPage,
  ],
  imports: [
    IonicPageModule.forChild(SubcategoriesPage),
    TranslateModule.forChild(),
    ComponentsModule,
    PipesModule
  ],
  exports: [
    SubcategoriesPage
  ]
})
export class SubcategoriesPageModule {}



// WEBPACK FOOTER //
// ./src/pages/subcategories/subcategories.module.ts